import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isChecked: true,
    pageerror: '',
    amount: '',
    amountdata:  null,
    isModalOpen: false,
    breakpoints: []
};

const amountSlice = createSlice({
    name: 'amount',
    initialState,
    reducers: {
        setIsChecked(state, action) {
            state.isChecked = action.payload;
        },
        setPageError(state, action) {
            state.pageerror = action.payload;
        },
        setAmount(state, action) {
            state.amount = action.payload;
        },
        setAmountData(state, action) {
            state.amountdata = action.payload;
        },
        openModal: (state) => {
            state.isModalOpen = true;
        },
        closeModal: (state) => {
            state.isModalOpen = false;
        },
        setBreakpoints: (state, action) => {
            state.breakpoints = action.payload;
        }
    },
});

export const { setIsChecked, setPageError, setAmount, setAmountData, openModal, closeModal, setBreakpoints } = amountSlice.actions;

export default amountSlice.reducer;
